import { NgClass } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { SasSpinnerService } from '@shared/services/sas-spinner.service';

@Component({
    selector: 'sas-spinner',
    standalone: true,
    imports: [TranslateModule, NgClass],
    template: `
        @if (isLoading() || isCustomLoading) {
        <div class="sas-spinner" [ngClass]="{'custom-loading': isCustomLoading}">
            <div class="loading">
                <span class="loader"></span>
                @if (!isCustomLoading) {
                <p class="loader-legend" role="alert" aria-live="assertive" translate="LOADING"></p>
                }
            </div>
        </div>
        }
    `,
    styleUrl: './sas-spinner.component.scss'
})
export class SasSpinnerComponent {
    @Input() isCustomLoading: boolean = false;

    spinnerService = inject(SasSpinnerService);

    isLoading = this.spinnerService.isLoading;
}
